import { render, staticRenderFns } from "./PagesTraffic.vue?vue&type=template&id=fffc7b3a&"
import script from "./PagesTraffic.vue?vue&type=script&lang=js&"
export * from "./PagesTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports